import React from "react";
import "./IconModification.css";
const DoubleQuote = () => {
  return (
    <div>
      <svg
        className="DoubleQuotes"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="30"
        height="30"
        viewBox="0 0 32 32"
      >
        <g>
          <g id="right_x5F_quote">
            <g>
              <path d="M0,4v12h8c0,4.41-3.586,8-8,8v4c6.617,0,12-5.383,12-12V4H0z" />
              <path d="M20,4v12h8c0,4.41-3.586,8-8,8v4c6.617,0,12-5.383,12-12V4H20z" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default DoubleQuote;
